module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/480.af2740ad.png";